import Head from 'next/head';
import PropTypes from 'prop-types';

export default function LCHead({
  title,
  description,
  canonical,
  image,
  author,
  editor,
  noIndex,
  jsonLd,
}) {
  return (
    <Head>
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      {canonical && <link rel="canonical" href={canonical} />}
      {canonical && <meta property="og:url" content={canonical} />}
      {image && <meta property="og:image" content={image} />}
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      {author && <meta property="author" content={author} />}
      {editor && <meta property="editor" content={editor} />}
      {noIndex && <meta name="robots" content="noindex,nofollow" />}
      <link rel="shortcut icon" href="/favicon.ico" />
      {Array.isArray(jsonLd) &&
        jsonLd.map((schema, index) => (
          <script
            // eslint-disable-next-line react/no-array-index-key
            key={`json-ld-${index}`}
            type="application/ld+json"
            // Escape `<` to avoid breaking out of the script tag via content
            // that may contain markup (e.g. FAQ answer text).
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: JSON.stringify(schema).replace(/</g, '\\u003c'),
            }}
          />
        ))}
    </Head>
  );
}

LCHead.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  canonical: PropTypes.string,
  image: PropTypes.string,
  author: PropTypes.string,
  editor: PropTypes.string,
  noIndex: PropTypes.bool,
  jsonLd: PropTypes.arrayOf(PropTypes.object),
};
